var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.044 14.15c.212.21.331.495.331.794v21.681c0 .622-.503 1.125-1.125 1.125h-22.5a1.124 1.124 0 01-1.125-1.125V7.375c0-.622.503-1.125 1.125-1.125h14.93c.3 0 .588.12.799.33l7.566 7.57zm-2.263 1.31l-6.617-6.615v6.616h6.616zm-7.554 5.34l-2.152 3.595-2.174-3.597a.421.421 0 00-.36-.204h-1.352a.423.423 0 00-.357.647l2.895 4.585-2.934 4.668a.42.42 0 00.357.647h1.212a.423.423 0 00.359-.2l2.204-3.568 2.19 3.567a.422.422 0 00.36.201h1.317a.422.422 0 00.355-.65l-2.947-4.59 3-4.657a.423.423 0 00-.356-.65h-1.255a.422.422 0 00-.362.205z",
    fill: "#006D75"
  })));
}

export default __webpack_public_path__ + "./fonts/xls.8e4f82f34427c4399b0198f1c01a6a3c.svg";
export { SvgXls as ReactComponent };